import { TextField, styled } from '@mui/material';

export const Textarea = styled(TextField)(() => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    padding: '0 !important',
    height: 'auto',
  },
}));
